import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Icon,
  makeStyles
} from '@material-ui/core';


const useStyles = makeStyles((theme) => ({
  dialogTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  closeButton: {
    marginLeft: theme.spacing(1),
  },
  closeIcon: {
    fontSize: 20,
  },
}));


const ErrorDialog = ({ error, isOpenDialog, setOpenDialog }) => {
  const classes = useStyles();

  return (
    <Dialog
      open={isOpenDialog}
      onClose={() => {
        setOpenDialog(false);
      }}
      maxWidth={'sm'}
      fullWidth
    >
      <DialogTitle disableTypography className={classes.dialogTitle}>
        <span>ERROR</span>
        <IconButton
          edge="end"
          color="inherit"
          size="small"
          onClick={() => {
            setOpenDialog(false);
          }}
          className={classes.closeButton}
          aria-label="close"
        >
          <Icon fontSize="small" className={classes.closeIcon}>close</Icon>
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <div className="flex justify-center p-3">
          {error}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ErrorDialog;
